<template>
    <card-with-image
        :image_url="app.comp_logo_blob_urls?.[0]"
        :image_height="340"
        :image_alt="`${app_label} Feature Image`"
        image_fit="contain"
        @click="onClickMoreInfo"
    >
        <template #image_overlay>
            <v-chip
                v-if="!app_is_installed && app_has_free_trial"
                class="chip-overlay"
                color="primary"
            >
                Try free for {{ app.free_trial_days_remaining }} days
            </v-chip>

            <v-chip
                v-if="app_is_update_eligible"
                class="chip-overlay"
                color="primary"
            >
                <v-icon
                    left
                    size="16"
                    aria-hidden="true"
                >mdi-update</v-icon>
                New Version Available
            </v-chip>

            <v-chip
                v-if="!app_is_approved"
                class="chip-overlay chip-overlay--left"
                color="primary"
            >
                <v-icon
                    left
                    size="16"
                    aria-hidden="true"
                >mdi-xml</v-icon>
                In Development
            </v-chip>
        </template>

        <template #content>
            <v-card-title class="d-flex flex-nowrap align-center justify-space-between gap-4 mb-1">
                <span class="line-height-1">{{ app_label }}</span>

                <p class="mb-0 text-subtitle-1 font-weight-medium primary--text">
                    {{ app_monthly_fee_pretty }}
                </p>
            </v-card-title>

            <v-card-subtitle class="text-muted pb-2">
                By {{ app.app_owner_organization_label || 'Unknown Developer' }}
            </v-card-subtitle>

            <v-card-text class="mt-1">
                <p class="mb-0">{{ app.app_description_short_md }}</p>
            </v-card-text>

            <app-install-or-update-dialog
                v-if="app"
                v-model="show_install_dialog"
                :app="app"
                :is_upgrade="app_is_update_eligible"
                @confirm="onInstallConfirm"
            />
        </template>

        <template #actions>
            <v-card-actions class="mb-1">
                <v-spacer />

                <v-btn
                    text
                    color="primary"
                    @click="onClickMoreInfo"
                >View Details</v-btn>

                <v-btn
                    v-if="is_organization_admin && app_is_installed"
                    outlined
                    color="primary"
                    @click="mixinOnClickUninstallApp(() => $emit('uninstalled', app), app_label)"
                >
                    <v-icon
                        size="20"
                        class="mr-1"
                        aria-hidden="true"
                    >mdi-delete</v-icon>
                    Uninstall
                </v-btn>

                <v-btn
                    v-if="is_organization_admin && !app_is_installed"
                    color="primary"
                    @click="onClickInstallOrUpdate"
                >
                    <v-icon
                        size="20"
                        class="mr-1"
                        aria-hidden="true"
                    >mdi-download</v-icon>
                    Install
                </v-btn>
            </v-card-actions>
        </template>
    </card-with-image>
</template>

<script>
import AppInstallation from '@/mixins/app-installation.js';
import AppDerived from '@/mixins/app-derived.js';
import AppInstallOrUpdateDialog from '@/components/app-store/app-install-or-update-dialog.vue';
import CardWithImage from '@/components/shared/cards/card-with-image.vue';

export default {
    name: 'AppSearchCard',

    mixins: [AppInstallation, AppDerived],

    components: {
        AppInstallOrUpdateDialog, CardWithImage
    },

    props: {
        app: { type: Object, required: true }
    },

    data() {
        return {
            show_install_dialog: false,
        };
    },

    computed: {
        is_organization_admin() {
            return this.$rc.$state.isOrganizationAdmin();
        }
    },

    methods: {
        onClickMoreInfo() {
            this.$router.push({
                name: 'app-details',
                params: { organization_id: this.app.organization_id, app_id: this.app.app_id },
            });
        },

        onClickInstallOrUpdate() {
            this.show_install_dialog = true;
        },

        onInstallConfirm({ app, agreement_specimen }) {
            this.mixinDoAppInstall(() => {
                this.$emit('installed', app);
            }, app.app_id, agreement_specimen);
        },
    },
};
</script>

<style lang="scss" scoped>
.v-card__title+.v-card__subtitle {
    margin-top: -1.25rem;
}

.chip-overlay {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 1;
    font-weight: bold;
    font-size: 0.8rem;

    &--right {
        left: auto;
        right: 10px;
    }

    &--bottom-left {
        top: auto;
        bottom: 10px;
        left: 10px;
    }

    &--bottom-right {
        top: auto;
        bottom: 10px;
        left: auto;
        right: 10px;
    }
}
</style>